import React, { useState } from "react";
import {
    TextField,
    List,
    ListItemAvatar,
    Avatar,
    ListItemText,
    ListItemButton,
    Stack
} from "@mui/material";
import {filtreOperateursContratEnCours} from "../../../../utils/contratHelper";
import ContratsEnCoursToggle from "./ContratsEnCoursToggle";

const OperateurPickerList = ({ operateurs = [], selected, onChange, allowNone = false }) => {
    const [search, setSearch] = useState("");
    const [enCours, setEnCours] = useState(true);

    const filteredOperateurs = (enCours ? operateurs.filter((o) => o.id === selected || filtreOperateursContratEnCours([o]).length > 0) : operateurs).filter((o) =>
        o.libelle?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Stack spacing={2}>
            <ContratsEnCoursToggle value={enCours} onChange={setEnCours}/>
            <TextField
                placeholder="Rechercher un opérateur"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                fullWidth
            />

            <List>
                {allowNone && (
                    <ListItemButton selected={!selected} onClick={() => onChange(null)}>
                        <ListItemText primary="Aucun" />
                    </ListItemButton>
                )}

                {filteredOperateurs.map((op) => (
                    <ListItemButton
                        key={op.id}
                        selected={selected === op.id}
                        onClick={() => onChange(op)}
                    >
                        <ListItemAvatar>
                            <Avatar>{op.libelle?.charAt(0) || "?"}</Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={op.libelle ?? op.email} />
                    </ListItemButton>
                ))}
            </List>
        </Stack>
    );
};

export default OperateurPickerList;
